import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {Store} from '@ngxs/store';
import {SesionState} from '@app/state/sesion/sesion.state';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { AppMainComponent } from './app.main.component';
import {environment} from '@env/environment';
import {menuOpciones} from './menu.opciones';
import {ConfigCompany} from '@app/domain/config-company';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit, OnDestroy {
    private stopped$ = new Subject<void>();
    private configCompany: ConfigCompany;

    model: any[];
    urlImageLogo: string;

    // tslint:disable-next-line:variable-name
    private _roles: any[];
    get roles() {
        return this._roles;
    }

    @Input()
    set roles(roles: any[]) {
        this._roles = roles;
        this.loadMenu();
    }

    constructor(public appMain: AppMainComponent, private store: Store) {}

    ngOnInit() {
        this.store.select(SesionState.getConfig).pipe(takeUntil(this.stopped$)).subscribe(config => {
            this.configCompany = config; this.loadMenu();
        });
        this.urlImageLogo = environment.urlLogo;
    }

    loadMenu() {
        if (this.roles) {
            menuOpciones.forEach(mit => {
                this.iterateMenu(mit);
            });
            this.model = menuOpciones;
        }
    }

    iterateMenu(item: any) {
        let visible = false;
        const rolesRequired = [...item.rol];
        rolesRequired.forEach(rr => {
            if (this.roles.find(r => r === rr)) {
                visible = true;
            }
        });

        item.visible = visible && (!item.requiresReturnableContainers ||
            (this.configCompany?.permitirRetornoEnvase && this.configCompany?.inventario));
        if (item.items) {
            item.items.forEach(it => {
                this.iterateMenu(it);
            });
        }
    }

    onMenuClick() {
        this.appMain.menuClick = true;
    }
    ngOnDestroy(): void { this.stopped$.next(); this.stopped$.complete(); }
}
